module.exports = __webpack_public_path__ + "img/page_info_noorder.6875d75.svg";